export const buildQueryString = (params?: Record<string, any>): string => {
  if (!params) {
    return '';
  }

  const query = Object.entries(params).reduce((result, [name, value]) => {
    if (value === null || value === undefined) {
      return result;
    }

    if (Array.isArray(value)) {
      const list = value.filter((val) => val !== null && val !== undefined);

      if (list.length > 0) {
        return [
          ...result,
          ...list.map((val) => `${encodeURIComponent(name)}=${encodeURIComponent(val)}`),
        ];
      }

      return result;
    }

    return [...result, `${encodeURIComponent(name)}=${encodeURIComponent(value)}`];
  }, [] as string[]);

  if (query.length > 0) {
    return `?${query.join('&')}`;
  }

  return '';
};

export const parseQueryString = (queryString: string) => {
  const result: Record<string, any> = {};

  if (['', '?'].includes(queryString)) {
    return result;
  }

  const splittedString = (
    queryString.startsWith('?') ? queryString.substring(1) : queryString
  ).split('&');

  splittedString.forEach((item) => {
    const [name, value] = item.split('=').map(window.decodeURIComponent);

    if (result[name] !== undefined) {
      if (Array.isArray(result[name])) {
        result[name].push(value);
      } else {
        result[name] = [result[name], value];
      }
    } else {
      result[name] = value;
    }
  });

  return result;
};
